/** @flow */
import {
  GetLoggedUserDashboardOverview,
  GetLoggedUserDashboardOverviewSuccess,
  GetLoggedUserDashboardOverviewError,
} from "@modules/reporting/constants/actions";
import * as userReducers from "./reducers";
import initialState from "./state";
import type { UserState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: UserState = initialState, action: *): UserState => {
  const act = {
    [GetLoggedUserDashboardOverview]: userReducers.setLoading,
    [GetLoggedUserDashboardOverviewSuccess]: userReducers.onGetLoggedUserDashboardOverviewSuccess,
    [GetLoggedUserDashboardOverviewError]: userReducers.onGetLoggedUserDashboardOverviewError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
